import { useState, useCallback, useEffect } from 'react';

let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState(false);
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userId, setUserId] = useState(false);
  const [userName, setUserName] = useState(false);
  const [userPermission, setUserPermission] = useState(false);
  const [userAvatar, setUserAvatar] = useState(false);
  const login = useCallback((uid, t, permission, nome, avatar, expirationDate) => {
    setToken(t);
    setUserId(uid);
    setUserPermission(permission);
    setUserAvatar(avatar);
    setUserName(nome);
    const ted = expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60 * 23.8);
    console.log(ted.toLocaleString());
    setTokenExpirationDate(ted);
    localStorage.setItem(
      'userData',
      JSON.stringify({
        userId: uid,
        token: t,
        userName: nome,
        userAvatar: avatar,
        userPermission: permission,
        expiration: ted.toISOString()
      })
    );
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);
    setUserPermission(null);
    setUserName(null);
    setUserAvatar(null);
    localStorage.removeItem('userData');
  }, []);

  const att = useCallback((nome, avatar) => {
    console.log('Atualizou perfil!');
    setUserName(nome);
    setUserAvatar(avatar);
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (
      storedData
      && storedData.token
      && storedData.userPermission
      && storedData.userName
      && new Date(storedData.expiration) > new Date()
    ) {
      login(storedData.userId, storedData.token, storedData.userPermission, storedData.userName, storedData.userAvatar, new Date(storedData.expiration));
    }
  }, [login]);
  return {
    token,
    login,
    logout,
    userId,
    userPermission,
    userName,
    userAvatar,
    att
  };
};
